<template>
    <div
        class="h-fit pinned-post-container white-rounded-box mb-5 mr-4 ml-5 sm:ml-0"
    >
        <div class="post-content-wrapper h-fit pl-7 pb-3">
            <div
                class="flex margin-auto justify-between text-center mr-9 mb-11"
            >
                <h2 class="mx-auto mt-5">Pinned Posts</h2>
            </div>
            <div class="text-center" v-if="!pinnedPosts.length">This pro has no pinned posts.</div>
            <Post
                :includeComments="false"
                v-for="post in pinnedPosts"
                :key="post.id"
                :post="post"
                :user="{}"
                :includePin="isOwnStorefront"
            />
        </div>
    </div>
</template>

<script>
import Post from "../../Utils/Post.vue";
export default {
    props: ["pinnedPosts", "isOwnStorefront"],
    components: {
        Post,
    },
};
</script>
